<template>
  <div class="express-wrapper">
    <div class="section">
      <div class="sectionInternal">
        <dl>
          <dt>
            <img src="../assets/icon20.png" alt="">
          </dt>
          <dd>
            <p>快件进口和BC直购</p>
            <span>收费合理透明/清关快捷安全</span>
          </dd>
        </dl>
        <div class="synopsis">
          <div class="sectionTop">
            <p>业务介绍</p>
            <div></div>
          </div>
          <div class="account">
            <p><span>快件进口</span>为境外电商和转运物流提供从海外到中国境内消费者终端 的一站式、高品质清关服务，采用快件形式清关，按照个人物品类，行邮 税征税，多口岸操作，将清关时效提升到48小时！</p>
            <p><span>BC直购</span>针对进口电商企业物流成本较高、非正规通关存在法律风 险等问题，平台为进口电商企业缩短通关时间、降低物流成本、提升利润 空间，解决灰色通关问题，为其打造一条透明、阳光、便捷的跨境通道！</p>
          </div>
        </div>
      </div>
      <div class="synopsisType">
        <div class="express">
          <div class="synopsisAll">
            <p @click="tabPackages" :class="packages?'active':''">快件进口</p>
            <p @click="tabDirect" :class="direct?'active':''">BC直购</p>
          </div>
          <div class="synopsisBox">
            <div class="expressImg" v-if="packages">
              <img src="../assets/img4.png" alt="">
              <p>系统对接</p>
              <p>打印面单</p>
              <p>发货到国内口岸</p>
              <p>提货到快检监管仓</p>
              <p>海关申报</p>
              <p>国内派送</p>
            </div>
            <div class="expressImgs" v-if="direct">
              <img src="../assets/img5.png" alt="">
              <p><span>海外收货</span>客户发送商品或包裹到海外仓 </p>
              <p><span>海外清关</span>对包裹进行海外清关</p>
              <p><span>国际运输</span>根据电商平台、企业的需求提供<br>多重运输方式将货物运输入国内</p>
              <p><span>国内清关</span>根据订单信息进行B2C直购<br>自动化电子清关</p>
              <p><span>国内派送</span>清关成功后进行国内派送服务<br>将包裹最终送入客户手中</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spot">
      <div class="sectionTop">
        <p>速派电商仓配业务优势</p>
      </div>
      <div class="spotCont">
        <dl>
          <dt>
            <img src="../assets/icon13.png" alt="">
          </dt>
          <dd>
            <p>中国邮政战略合作伙伴</p>
            <p>与天津邮政紧密合作 为客户打造 快件进口解决方案</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon14.png" alt="">
          </dt>
          <dd>
            <p>自有清关牌照</p>
            <p>安全、快捷、合法的正规通关渠道 将顾客的包裹送抵目的地</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon11.png" alt="">
          </dt>
          <dd>
            <p>多口岸清关</p>
            <p>立足天津、一站联网厦门 广州等全国多个口岸</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon7.png" alt="">
          </dt>
          <dd>
            <p>一站到底</p>
            <p>订舱/办理进出口许可证等业务</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon9.png" alt="">
          </dt>
          <dd>
            <p>易用的软件系统</p>
            <p>严谨的研发团队 提供高效的软件服务</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon12.png" alt="">
          </dt>
          <dd>
            <p>多渠道客服系统</p>
            <p>支持PC、电话、App、Wap、 微信、微博、邮件、H5等多渠道接入</p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Express',
  props:{

  },
  components:{

  },
  data(){
    return {
      packages:true,
      direct:false
    }
  },
  computed:{

  },
  methods:{
    tabPackages(){
      this.packages = true;
      this.direct = false;
    },
    tabDirect(){
      this.packages = false;
      this.direct = true;
    }
  },
  created(){

  },
  mounted(){

  }
}
</script>
<style scoped lang="scss">
.section {
  width: 100%;
  min-height: 360px;
  margin: 30px 0;
  .sectionInternal {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    dl {
      padding: 0 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 80px;
      min-height: 300px;
      width: 300px;
      dt {
        width: 160px;
        height: 130px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      dd {
        p {
          font-size: 23px;
          color: rgb(36,35,35);
          text-align: center;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        span {
          font-size: 18px;
          text-align: center;
          color: rgb(36,35,35);
        }
      }
    }
    .synopsis{
      width: 560px;
      .sectionTop {
        align-items: flex-start;
      }
      .account {
        p {
          word-break:break-all;
          text-indent: 20px;
          font-size: 16px;
          color: rgb(117,115,115);
          padding-top: 20px;
          line-height: 38px;
          span {
            color: $bg-color;
            font-size: 25px;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .synopsisType {
    width: 100%;
    margin: 30px 0;
    background: #f5f5f5;
    .express {
      width: 1000px;
      margin: 0 auto;
      .synopsisAll {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        margin-bottom: 30px;
        p {
          margin: 0 10px;
          min-width: 350px;
          text-align: center;
          line-height: 60px;
          font-size: 30px;
          box-shadow: 0 3px 3px 0 #ccc;
          color: #757373;
          background: #fff;
          cursor: pointer;
        }
        p.active {
          background: $bg-color;
          color: #fff;
        }
      }
      .synopsisBox {
        width: 100%;
        height: 100%;
        min-height: 300px;
        .expressImg {
          margin-bottom: 40px;
          min-height: 300px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          p {
            position: absolute;
            bottom: 6%;
            left: 17%;
            font-size: 10px;
          }
          p:nth-child(3){
            top: 6%;
            left: 27%;
          }
          p:nth-child(4){
            bottom: 6%;
            left: 36%;
          }
          p:nth-child(5){
            top: 6%;
            left: 46%;
          }
          p:nth-child(6){
            bottom: 6%;
            left: 61%;
          }
          p:nth-child(7){
            top: 6%;
            left: 75%;
          }
        }
        .expressImgs {
          margin-bottom: 40px;
          min-height: 330px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          p {
            position: absolute;
            bottom: 0%;
            left: 19%;
            font-size: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            word-break: break-all;
            /*width: 160px;*/
          }
          p:nth-child(3){
            top: 0;
            left: 32%;
          }
          p:nth-child(4){
            bottom: 0;
            left: 40%;
          }
          p:nth-child(5){
            top: 0;
            left: 51%;
          }
          p:nth-child(6){
            bottom: 0;
            left: 63%;
          }
        }
      }
    }
  }
}
.spot {
  width: 1000px;
  margin: 0 auto;
  .spotCont {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    justify-content: space-around;
    dl {
      width: 28%;
      height: 130px;
      margin: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      dt {
        width: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      dd {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
          width: 100%;
          text-align: center;
          font-size: 17px;
          line-height: 30px;
          word-break: break-all;
          height: 30px;
          margin-bottom: 5px;
        }
        p:not(:first-child) {
          font-size: 13px;
          height: 60px;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Express.vue